module.exports = __webpack_public_path__ + "img/login-v2.50574655.svg";